import { AbAccordion, AbAccordionItem } from "../../widgets/accordion";
import { AbBadgeOverlay } from './badge-overlay/badge-overlay.js';
import { BaseComponent } from "../../base.component.js";
import { AbCroppedText } from '../../widgets/cropped-text/cropped-text.widget.js';

/**
 * Accordion adapted for the different badge types (plan/variant) and companies
 * @typedef {RenderableProps} _AbContainerItem_Props
 */
export class AbBadgeAccordion extends BaseComponent {

  /**
   * @param {_AbContainerItem_Props} props
   */
  constructor(props) {
    super(props);
    this.state = {};
    this.onSelectedIndexChanged = this.selectedIndexChanged.bind(this);
  }

  componentDidMount() {
    this.setState({
      overlayVisible: false
    });
  }

  selectedIndexChanged(index) {
    this.setState({
      overlayVisible: index >= 0
    });
  }

  render({ texts, company, plan, variant, product, size, useOverlay, showTuv}) {
    const { txt, formatDate } = this.context;
    // TODO: Replace with the tuv verify date when available
    const companyUrl = company ? <AbCroppedText maxChars={30} text={company.homepageBare} emphasis /> : "";
    const brandName = product ? <AbCroppedText maxChars={30} text={product.brand.displayName} emphasis /> : "";
    const tuvVerificationDate = <AbCroppedText text={formatDate(company.tuvApprovalDate, "MMM yyyy")} emphasis />;
    return (
      <div>
        <AbBadgeOverlay isVisible={this.state && this.state.overlayVisible && useOverlay} />
        <AbAccordion className="ab-badge-accordion" onSelectedIndexChanged={this.onSelectedIndexChanged}>
          {(variant === "mid" || variant === "island") && plan === "premium" && product &&
            <AbAccordionItem title={txt(texts.originalityConfirmedTitle)} size={size}  >
              {txt(texts.originalityConfirmedText, { url: companyUrl, brand: brandName })}
            </AbAccordionItem>
          }
          {(variant === "mid" || variant === "island") && plan === "premium" && product &&
            <AbAccordionItem title={txt(texts.authRetailerTitle)} size={size} >
              {txt(texts.authRetailerText, { url: companyUrl, brand: brandName })}
            </AbAccordionItem>
          }
          {(showTuv || product && (product.brandSponsored || product.officialBrandShop)) && (variant === "mid" || variant === 'footer' || variant === 'island') && (plan === "start" || plan === "premium") &&
            <AbAccordionItem title={txt(texts.shopCheckTitle)} tuevSeal={showTuv} size={size} >
              {txt(texts.shopCheckText, { url: companyUrl, date: tuvVerificationDate, brand: brandName })}
            </AbAccordionItem>
          }
        </AbAccordion>
      </div>
    );
  }
}
